import script from "./imagemInput.vue?vue&type=script&setup=true&lang=js"
export * from "./imagemInput.vue?vue&type=script&setup=true&lang=js"

import "./imagemInput.vue?vue&type=style&index=0&id=5f7778c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f7778c6"]])

export default __exports__